import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/landing/landing.component').then(m => m.LandingComponent),
    data: {
      seo: {
        title: 'ALL-IN-DEV – Üzleti weboldalak vállalkozásoknak',
        description: 'Weboldal, ami nem csak úgy van – hanem dolgozik is a vállalkozásodért.',
      }
    }
  },
  {
    path: 'adatvedelmi-nyilatkozat',
    loadComponent: () =>
      import('./pages/privacy/privacy.component').then(m => m.PrivacyComponent),
  },
  {
    path: 'impressum',
    loadComponent: () =>
      import('./pages/impressum/impressum.component').then(m => m.ImpressumComponent),
  },
  { path: '**', redirectTo: '' }
];
